import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player/lazy';

import Icon from '../Icon';

/**
 * VideoPlayer
 */

class VideoPlayer extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    this.play = () => this.setState({ isPlaying: true });
    this.pause = () => this.setState({ isPlaying: false });
    this.paused = () => !this.state.isPlaying;
    this.togglePlayPause = () => this.setState({ isPlaying: !this.state.isPlaying });

    /** State */
    this.state = { isPlaying: this.props.play };

    /** Refs */
    this.element = React.createRef();
  }

  render() {
    const elementClass = this.props?.className || 'video-player';
    const countClass = this.props.count ? 'l-count' : '';
    return (
      <div ref={this.element} className={`${elementClass} ${countClass}`} onClick={() => this.play()}>
        {this.props.legend && <span dangerouslySetInnerHTML={{ __html: this.props.legend }} className="video-player-legend" />}
        <ReactPlayer
          url={this.props.url}
          playing={this.state.isPlaying}
          controls={this.props.controls}
          loop={this.props.loop}
          volume={1}
          muted={this.props.muted}
          light={this.props.poster ? this.props.poster : this.state.isPlaying ? false : true}
          playIcon={<Icon icon="play" layout="text-white" />}
        />
      </div>
    );
  }
}

VideoPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  poster: PropTypes.string,
  play: PropTypes.bool,
  loop: PropTypes.bool,
  muted: PropTypes.bool,
  controls: PropTypes.bool,
  legend: PropTypes.string,
  className: PropTypes.string,
  count: PropTypes.bool,
};

VideoPlayer.defaultProps = {
  play: false,
  loop: false,
  muted: false,
  controls: false,
};

export default VideoPlayer;
